import { render, staticRenderFns } from "./projectManagement.vue?vue&type=template&id=0053147e&scoped=true"
import script from "./projectManagement.vue?vue&type=script&lang=js"
export * from "./projectManagement.vue?vue&type=script&lang=js"
import style0 from "./projectManagement.vue?vue&type=style&index=0&id=0053147e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0053147e",
  null
  
)

export default component.exports